import ListViewStore from 'mini-mail-list-store/lib/store/schema/ListViewStore';
import TableView from 'mini-mail-list-store/lib/store/schema/TableView';
import { getListViewStore } from 'mini-mail-list-store/lib/store/Store';
import { TableQueryType } from 'mini-mail-list-store/lib/store/schema/TableQuery';

/**
 * Returns array of table views where table query matches the folderId
 * @param folderId is the matching criteria for table views
 * @param shouldIncludeSearchTable includes table view of search type
 */
export default function getAllTableViewsContainingItemsForFolder(
    folderId: string,
    shouldIncludeSearchTable: boolean
): TableView[] {
    const allTableViewsOfFolder = [];
    const listViewStore: ListViewStore = getListViewStore();

    listViewStore.tableViews.forEach(tableView => {
        // Include search table if specified
        if (
            tableView.tableQuery.folderId === folderId ||
            (shouldIncludeSearchTable && tableView.tableQuery.type === TableQueryType.Search)
        ) {
            allTableViewsOfFolder.push(tableView);
        }
    });

    return allTableViewsOfFolder;
}
